import {
  AccountBalance as AccountBalanceIcon,
  Business as BusinessIcon,
  Person as PersonIcon,
  Work as WorkIcon,
} from '@mui/icons-material';
import React from 'react';
import { RecentlyViewedItem } from 'RecentlyViewed';
import { getModelLabel } from '../../utils/ModelIconMapping';

export const pluralizeModelLabel = (modelType: string): string => {
  const singularLabel = getModelLabel(modelType);

  if (singularLabel.endsWith('y')) {
    return singularLabel.slice(0, -1) + 'ies';
  }

  return singularLabel + 's';
};

export const getRecentlyViewedNavigationPath = (item: RecentlyViewedItem): string => {
  const { modelType: type, modelId: id } = item;

  const modelTypeToPath: Record<string, string> = {
    CONTACT: `/contacts/${id}`,
    ADMIN_USER: `/adminUsers/${id}`,
    INVESTOR: `/opportunities/${item.modelData?.fundOpportunityId}/investors/${id}`,
    FUND_OPPORTUNITY: `/opportunities/${id}`,
    INVESTMENT_ENTITY: `/entities/${id}`,
    EOI: `/opportunities/${id}`,
    ALLOCATION: `/allocations/${id}`,
    GLOBAL_CONFIG: `/globalConfig`,
    USER: `/users/${id}`,
  };
  return modelTypeToPath[type] || `/models/${type.toLowerCase()}/${id}`;
};

export const getModelIcon = (modelType: string) => {
  const iconMap: Record<string, React.ReactElement> = {
    CONTACT: <PersonIcon sx={{ fontSize: 16 }} />,
    FUND_OPPORTUNITY: <BusinessIcon sx={{ fontSize: 16 }} />,
    INVESTMENT_ENTITY: <AccountBalanceIcon sx={{ fontSize: 16 }} />,
    INVESTOR: <WorkIcon sx={{ fontSize: 16 }} />,
    ADMIN_USER: <PersonIcon sx={{ fontSize: 16 }} />,
  };
  return iconMap[modelType] || <BusinessIcon sx={{ fontSize: 16 }} />;
};

export const getModelDisplayName = (item: RecentlyViewedItem) => {
  if (item.modelData) {
    if (item.modelData.firstName && item.modelData.lastName) {
      return `${item.modelData.firstName} ${item.modelData.lastName}`;
    }
    if (item.modelData.name) {
      return item.modelData.name;
    }
    if (item.modelData.email) {
      return item.modelData.email;
    }
  }
  return item.modelId;
};
